module.exports = __webpack_public_path__ + "img/description2.517d46e8.jpg";